import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { SortByPipe } from './pipes/sort-by.pipe';
import { MaterialModule } from './material.module';
import { SharedService } from './common/shared.service';
import { SiteResDialogComponent } from './sites/site-restriction/siteres-dialog.component';
import { AuthorizationCheck } from './Services/authorizationCheck.component';
import { RequestInterceptorService } from './Interceptor/request-interceptor.service';
import { RecentComponent } from './recent/recent.component';
import { FavouriteComponent } from './favourite/favourite.component';
import { SitesComponent } from './sites/sites.component';
import { FolderComponent } from './folder/folder.component';
import { FilterPipe } from './pipes/filter.pipe';
import { FileSizePipe } from './pipes/file-size.pipe';
import { LoginComponent } from './login/login.component';
import { InstanceComponent } from './instance/instance.component';
import { OAuthComponent } from './oAuth/oAuth.component';
import { SettingsComponent } from './settings/settings.component';
import { ShareSettingsDialogComponent } from './settings/sharesettings-dialog.component';
import { UploadComponent } from './upload/upload.component';
import { DndDirective } from './upload/dnd.directive';
import { ProgressComponent } from './progress/progress.component';
import { CommonModule } from '@angular/common';
import { AccessDeniedComponent } from './accessdenied/accessdenied.component';
import { PassowordStrengthBarComponent } from './passwordbar/password-strength-bar.component';
import { DuplicateDialogComponent } from './upload/duplicate-dialog.component';




@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    SiteResDialogComponent,

    RecentComponent,
    FavouriteComponent,
    SitesComponent,
    FolderComponent,
    FilterPipe,
    FileSizePipe,
    SortByPipe,
    LoginComponent,
    InstanceComponent,
    OAuthComponent,
    SettingsComponent,
    ShareSettingsDialogComponent,
    DuplicateDialogComponent,
    UploadComponent,
    DndDirective,
    ProgressComponent,
    PassowordStrengthBarComponent  
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    MaterialModule,
    CommonModule,

    ReactiveFormsModule,
    //PipesModule,
    //FileSizePipeModule,
   

    RouterModule.forRoot([
      { path: '', component: LoginComponent },
      { path: 'login', component: LoginComponent },
      { path: 'instance', component: InstanceComponent},
      { path: 'oAuth', component: OAuthComponent },
      { path: 'recent', component: RecentComponent, canActivate: [AuthorizationCheck] },
      { path: 'favourite', component: FavouriteComponent, canActivate: [AuthorizationCheck] },
      { path: 'sites', component: SitesComponent, canActivate: [AuthorizationCheck] },
      { path: 'folder/:folderId/:type/:name', component: FolderComponent, canActivate: [AuthorizationCheck] },
      { path: 'settings', component: SettingsComponent, canActivate: [AuthorizationCheck]  },
      { path: 'upload', component: UploadComponent, canActivate: [AuthorizationCheck] },
      { path: 'accessdenied', component: AccessDeniedComponent},
      // {
      //   path: '',
      //   loadChildren: () => import('./login/ .module').then(m => m.LoginModule)
      // },
      // {
      //   path: 'login',
      //   loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
      // },

      // {
      //   path: 'instance',
      //   loadChildren: () => import('./instance/instance.module').then(m => m.InstanceModule)
      // },

      // {
      //   path: 'recent',
      //   canActivate: [AuthorizationCheck],
      //   loadChildren: () => import('./recent/recent.module').then(m => m.RecentModule)
      // },
      // {
      //   path: 'favourite',
      //   canActivate: [AuthorizationCheck],
      //   loadChildren: () => import('./favourite/favourite.module').then(m => m.FavouriteModule)
      // },
      // {
      //   path: 'sites',
      //   canActivate: [AuthorizationCheck],
      //   loadChildren: () => import('./sites/sites.module').then(m => m.SitesModule)
      // },
      // {
      //   path: 'oAuth',
      //   loadChildren: () => import('./oAuth/oAuth.module').then(m => m.OAuthModule)
      // },
      // {
      //   path: 'folder/:folderId/:type/:name',
      //   canActivate: [AuthorizationCheck],
      //   loadChildren: () => import('./folder/folderfile.module').then(m => m.FolderFileModule)
      // },
      // {
      //   path: 'settings',
      //   canActivate: [AuthorizationCheck],
      //   loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule)
      // },

      // {
      //   path: 'upload',
      //   canActivate: [AuthorizationCheck],
      //   loadChildren: () => import('./upload/upload.module').then(m => m.UploadModule),
      // },
      // {
      //   path: 'accessdenied',
      //   loadChildren: () => import('./accessdenied/accessdenied.module').then(m => m.AccessDeniedModule),
      // },
//      { path: 'accessdenied', component: AccessDeniedComponent, pathMatch: 'full' },
    ])
  ],
 // exports: [RouterModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptorService, multi: true },
    SharedService, AuthorizationCheck, SortByPipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
